import { DataListService } from '../common/data/data-list.service';
import * as i0 from "@angular/core";
import * as i1 from "../common/auth/auth-api-http-client";
export class PcListService extends DataListService {
    constructor(httpClient) {
        super({
            httpClient,
            url: 'auth/pcs',
            initial: []
        });
    }
}
PcListService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PcListService_Factory() { return new PcListService(i0.ɵɵinject(i1.AuthApiHttpClient)); }, token: PcListService, providedIn: "root" });
